module.exports = __webpack_public_path__ + "static/kv-7d67715957a4f493e463f935723bcd22.jpg";